import { render, staticRenderFns } from "./OpenForestRedeemFlow.vue?vue&type=template&id=3de1e538&"
import script from "./OpenForestRedeemFlow.vue?vue&type=script&lang=ts&"
export * from "./OpenForestRedeemFlow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports